import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromButtons from '../buttons/buttons.reducer';

export interface ButtonsState {
  buttons: fromButtons.ButtonsState;
}

export const reducers: ActionReducerMap<ButtonsState> = {
  buttons: fromButtons.buttonsReducer,
};

export const selectButtonsState = createFeatureSelector<fromButtons.ButtonsState>(fromButtons.inRoomButtonsFeatureKey);

export const selectButtonEntities = createSelector(selectButtonsState, fromButtons.selectButtonsEntities);

export const getButtonPressForRoom = (location: string, room: string) =>
  createSelector(selectButtonEntities, (entities) => entities[fromButtons.selectButtonPressedId(location, room)]);
